import { FilterObject } from './utils/reportTypes';

export const downloadCSV = (blob: string, filename: string): void => {
    const link = document.createElement('a');
    link.style.cssText = 'display: none;';
    link.href = blob;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
};

export const idArrayToString = (array: FilterObject[]): string => {
    return array.map((item) => item?.value as number).join(',');
};
